import { API_RESOURCE } from '@/constants/api.constant'
import useAction from '@/hooks/useAction'
import { createQueryKey } from '@/lib/react-query'
import OfferQuotationApprovalService from '../services/offerQuotationApproval.service'

const useOfferQuotationApproval = () => {
  const service = new OfferQuotationApprovalService()
  const queryKey = createQueryKey(API_RESOURCE.OFFER)

  const useInviteQuotationUser = useAction({
    mutationFn: service.inviteQuotationUser,
    queryKey: queryKey,
    message: 'Successfully invited user to quotation approval',
  })

  const useReplyQuotationInvitation = useAction({
    mutationFn: service.replyQuotationInvitation,
    queryKey: queryKey,
    message: 'Successfully replied to quotation invitation',
  })

  const useDeleteQuotationInvitedUsers = useAction({
    mutationFn: service.deleteQuotationInvitedUsers,
    queryKey: queryKey,
    message: 'Successfully removed quotation invited users',
  })

  return {
    useInviteQuotationUser,
    useReplyQuotationInvitation,
    useDeleteQuotationInvitedUsers,
  }
}

export default useOfferQuotationApproval
